import { motion } from 'framer-motion';
import {
  Plus,
  Bike,
  Footprints,
  Mountain,
  Coffee,
  Headphones,
  Dumbbell,
  BookOpen,
  Music,
  Gamepad2,
  Camera,
  Plane,
  Utensils,
  Heart,
  Sparkles,
} from 'lucide-react';

const INTEREST_ICON_MAP = {
  cycling: Bike,
  running: Footprints,
  hiking: Mountain,
  trips: Mountain,
  travel: Plane,
  coffee: Coffee,
  cafés: Coffee,
  cafes: Coffee,
  music: Headphones,
  badminton: Sparkles,
  football: Sparkles,
  cricket: Sparkles,
  gym: Dumbbell,
  yoga: Heart,
  reading: BookOpen,
  gaming: Gamepad2,
  photography: Camera,
  cooking: Utensils,
  movies: Music,
  swimming: Sparkles,
  tennis: Sparkles,
  basketball: Sparkles,
  dancing: Music,
  meditation: Heart,
  art: Sparkles,
  volunteering: Heart,
};

function iconForInterest(label) {
  const key = String(label || '').toLowerCase().trim();
  return INTEREST_ICON_MAP[key] || Sparkles;
}

const InterestScroller = ({ interests = [], isOwnProfile, onAddInterest }) => {
  const items = Array.isArray(interests) ? interests.filter(Boolean) : [];

  if (!isOwnProfile && items.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.12 }}
      className="mt-6 -mx-4 px-4 sm:-mx-0 sm:px-0"
    >
      {/* pt-1 keeps ring borders from clipping under overflow-x */}
      <div className="flex gap-4 overflow-x-auto overflow-y-visible pt-1 pb-2 scrollbar-hide">
        {isOwnProfile && (
          <button
            type="button"
            onClick={onAddInterest}
            className="flex w-[68px] shrink-0 flex-col items-center gap-1.5"
          >
            <span className="flex h-[62px] w-[62px] items-center justify-center rounded-full border-2 border-dashed border-surface-300 text-surface-400 transition hover:border-brand-400 hover:text-brand-500 dark:border-surface-600 dark:text-surface-500">
              <Plus size={22} strokeWidth={2} />
            </span>
            <span className="text-[11px] font-medium text-surface-500 dark:text-[#B5BDD1]">New</span>
          </button>
        )}

        {items.map((label, i) => {
          const Icon = iconForInterest(label);
          return (
            <div
              key={`${label}-${i}`}
              className="flex w-[68px] shrink-0 flex-col items-center gap-1.5"
            >
              <span className="flex h-[62px] w-[62px] items-center justify-center rounded-full bg-brand-50 ring-2 ring-brand-400/70 dark:bg-brand-500/10 dark:ring-brand-400/50">
                <Icon size={24} className="text-brand-600 dark:text-brand-400" strokeWidth={1.6} />
              </span>
              <span className="max-w-full truncate text-[11px] font-medium text-surface-700 dark:text-[#B5BDD1]">
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default InterestScroller;
